import React, {useState, useEffect} from "react"
import { window } from 'browser-monads'
import { makeStyles } from '@material-ui/core/styles'

import HomePage from "./home"

const useStyles = makeStyles({
    container: {
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    loader: {
        display: 'block'
    }
})
const IndexPage = () => {
    const classes = useStyles()
    const [agreed, setAgreed] = useState(false)
    
    setTimeout(() => {
        setAgreed(true)
        window.localStorage.setItem('agreed', true)
        window.location.href = '/home'
    }, 5000)
    return (<div className={classes.container}>
        <img src="logo-animated.gif" height="320" width="320" className={classes.loader} />
    </div>)
}

export default IndexPage
